import { WrapReadableStream, WrapWritableStream } from '@yume-chan/adb';
export default class AdbDirectSocketsBackend {
    static isSupported() {
        return typeof window !== 'undefined' && !!window.navigator?.openTCPSocket;
    }
    serial;
    host;
    port;
    name;
    constructor(host, port = 5555, name) {
        this.host = host;
        this.port = port;
        this.serial = `${host}:${port}`;
        this.name = name;
    }
    async connect() {
        const { readable, writable } = await navigator.openTCPSocket({
            remoteAddress: this.host,
            remotePort: this.port,
            noDelay: true,
        });
        // Native streams can't `pipeTo()` or `pipeThrough()` polyfilled streams, so we need to wrap them
        return {
            readable: new WrapReadableStream({
                async start() {
                    return {
                        readable,
                        state: undefined,
                    };
                }
            }),
            writable: new WrapWritableStream({
                async start() {
                    return {
                        writable,
                        state: undefined,
                    };
                }
            }),
        };
    }
}
//# sourceMappingURL=index.js.map